<template>
  <div class="relative">
    <input v-model="search_term" @input="searchCompany($event.target.value)" class="outlined" placeholder="Search by Company">
    <div class="search_results">
      <div v-for="company in search_company_results" :key="company.id" class="search_result text_align_right" style="cursor: auto;">
        <router-link :to="{ name: $route.name, query: { ...$route.query, company_id: company.resource_id, company_name: company.name, statuses: '', position_title: '' } }">
          <u @click="onClickCompanyName($event, company)">{{company.name}}</u>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'search-companies',
  props: {
    anchor: {
      type: String
    }
  },
  data () {
    return {
      search_term: '',
      search_company_results: []
    }
  },
  methods: {
    searchCompany (search_term) {
      this.$network_utils.searchCompany({ name: search_term }).then(response => {
        this.search_company_results = response
      })
    },
    onClickCompanyName (event, company) {
      this.search_company_results = []
      if (this.anchor === 'input_filters') {
        event.preventDefault()
        this.$emit('select', { name: company.id })
        this.search_term = company.name
        return
      }
      if (this.$listeners.select != undefined) {
        event.preventDefault()
        this.$emit('select', company)
      }
    },
    clearText () {
      this.search_term = ''
    }
  }
}
</script>
